import httpClient from "@/plugins/axios";

export const getSurveys = async (page = 1, pageSize = 100) => {
    const response = await httpClient.get(`/v1/surveys/?page=${page}&page_size=${pageSize}`);
    return response;
}

export const getSurvey = async (id) => {
    const response = await httpClient.get(`/v1/surveys/${id}/`);
    return response;
}

export const submitSurvey = async (id, responses) => {
    const response = await httpClient.post(`/v1/surveys/${id}/submit/`, { responses });
    return response;
}
